// extracted by mini-css-extract-plugin
module.exports = {"EditorPersonal":"_3XIJQtdK","firstBlock":"aR6PAPLF","titleBlock":"_1A5aRmTV","title":"-GkO6sJt","scrollDiv":"_1WJyqPCG","titleContainer":"_3_IRNlVD","phoneEmailInputs":"_3ZD-3Q6j","nameInputs":"_378DKemq","permPlaceholder":"_2W06z7ii","autoSaving":"_3YK0ddXy","autoSaved":"_1y3bK4s3","saveContent":"_3sga0-5s","label":"_3BIo7N8w","errorText":"jEQPC6V9","emailContent":"_26AKHe-C","flexColumn":"_1oLM4zHw"};
    if(module.hot) {
      // 1754514988461
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  